import React, { createContext, useState, useEffect } from 'react';
import { onSnapshot, query, collection, where} from 'firebase/firestore';
import useCollection from "../hooks/useCollection";
import useAuth from '../hooks/useAuth';

export const QuotesContext = createContext();

const QuotesContextProvider = (props) => {
  const [quotes, setQuotes] = useState([]);
  const [myQuotes, setMyQuotes] = useState([]);
  const { db, user } = useAuth();
  const [docs, setDocs] = useState(null)
  const pathQuotes = `quotes`
  const pathMyQuotes = `users/${user.id}/quotes`
  const quotesRef = collection(db, pathQuotes);


  //

  useEffect(() => {
    //
    const q = query(quotesRef);
		 onSnapshot(q, (querySnapshot) => {
		  const documents = [];
		  querySnapshot.forEach((doc) => {
			documents.push({id: doc.id, ...doc.data()});
			setQuotes({...documents, documents});
			// console.log(`useCollection documents.length= ${documents.length}`)
		  });
		});

  }, [pathQuotes, pathMyQuotes]);

  return (
    <QuotesContext.Provider
      value={{
        quotes,
        setQuotes,
        myQuotes,
        setMyQuotes
      }}
    >
      {props.children}
    </QuotesContext.Provider>
  );
};

export default QuotesContextProvider;
